// _shared/hooks/useColors.js
import { useState, useEffect, useRef } from 'react';
import { colorService } from '../../_services/colorService';

export const useColors = (slug) => {
  const [colors, setColors] = useState({
    primaryColor: '#9370DB',
    secondaryColor: '#40E0D0',
    textColor: '#FFFFFF',
    backgroundColor: '#0b0b1a',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Cargar colores
   */
  useEffect(() => {
    const fetchColors = async () => {
      if (!slug) {
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);
      
      try {
        const data = await colorService.getColors(slug);
        if (data) {
          setColors(data);
        } else {
          // Si no hay colores guardados, usar los que vienen del template o defaults
          setColors(colorService.getDefaultColors());
        }
      } catch (error) {
        console.error('Error al cargar colores:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchColors();
  }, [slug]);

  /**
   * Manejar cambio de color
   */
  const handleColorChange = (e) => {
    const { name, value } = e.target;
    setColors((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /**
   * Guardar colores
   */
  const handleSaveColors = async () => {
    if (!slug) {
      alert('Error: No se puede guardar porque el slug no está definido.');
      return false;
    }

    setSaving(true);
    setError(null);

    try {
      await colorService.saveColors(slug, colors);
      alert('Colores guardados exitosamente');
      return true;
    } catch (error) {
      console.error('Error al guardar los colores:', error);
      setError(error.message);
      alert('Error al guardar los colores');
      return false;
    } finally {
      setSaving(false);
    }
  };

  /**
   * Resetear a colores por defecto
   */
  const resetToDefaults = () => {
    setColors(colorService.getDefaultColors());
  };

  return {
    // Estado
    colors,
    loading,
    saving,
    error,

    // Setters
    setColors,

    // Handlers
    handleColorChange,
    handleSaveColors,
    resetToDefaults,
  };
};